export default {
  data() {
    return {
      activeRaasi: this.$route.query.raasi || null
    }
  },
  methods: {
    setActiveRaasi(value) {
      this.activeRaasi = value

      // update query params
      const query = Object.assign({}, this.$route.query);

      delete query.raasi;

      query.page = 1;

      if (this.$route.query !== query) {
        // to avoid duplicate navigation
        this.$router.push({ query: query })
      }
    }
  },
  watch: {
    activeRaasi(newValue) {
      const query = Object.assign({}, this.$route.query, { raasi: newValue });

      if (!newValue || newValue == '-1') {
        delete query.raasi;
      }

      const sameNumOfParams = Object.keys(this.$route.query).length === Object.keys(query).length

      if (sameNumOfParams) {
        const sameParams = Object.keys(this.$route.query).every(key => this.$route.query[key] === query['key'])

        if (!sameParams) {
          this.$router.push({ query: query })
        }
      } else {
        this.$router.push({ query: query })
      }
    }
  }
}
